import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1280.000000 853.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,565.000000) scale(0.100000,-0.100000)" >


<path d="M5307 5843 c-4 -3 -7 -15 -7 -25 0 -11 -4 -16 -10 -13 -5 3 -10 -3
-10 -13 0 -11 -7 -22 -15 -26 -8 -3 -15 -12 -15 -21 0 -8 -6 -15 -13 -15 -7 0
-19 -8 -26 -19 -8 -10 -21 -16 -30 -14 -10 2 -23 -2 -29 -10 -20 -24 -43 -134
-40 -192 l3 -55 40 27 c22 16 49 36 60 46 11 10 39 30 63 44 l42 25 0 134 c0
74 -1 134 -3 134 -2 0 -7 -3 -10 -7z"/>
<path d="M4999 5578 c0 -18 -3 -27 -6 -20 -8 19 -23 14 -23 -8 0 -12 -7 -20
-16 -20 -9 0 -18 -9 -21 -20 -3 -11 -9 -20 -13 -20 -4 0 -23 -15 -43 -34 -29
-27 -37 -30 -40 -17 -1 9 -6 -31 -11 -88 -4 -57 -5 -105 -3 -108 5 -4 25 9
154 102 l42 30 1 112 c0 64 -4 114 -10 118 -6 4 -10 -8 -11 -27z"/>
<path d="M4693 5399 c-18 -5 -33 -16 -33 -24 0 -8 -9 -19 -20 -25 -11 -6 -18
-15 -15 -20 7 -11 -40 -24 -54 -15 -7 4 -11 -11 -12 -42 0 -36 -3 -43 -9 -28
-7 16 -9 12 -11 -20 -7 -107 -6 -185 2 -185 10 0 78 43 141 90 l47 35 1 123
c0 67 -1 122 -2 121 -2 0 -18 -5 -35 -10z"/>
<path d="M2781 5293 c-20 -21 -37 -40 -38 -43 0 -3 -8 -29 -17 -59 -9 -30 -15
-73 -15 -95 1 -23 3 -33 6 -23 2 9 9 17 15 17 6 0 8 13 4 34 -4 18 -2 44 3 57
9 21 10 18 12 -21 3 -89 5 -97 27 -127 12 -17 22 -40 22 -51 0 -12 4 -23 9
-27 5 -3 12 -18 16 -33 5 -26 65 -104 65 -86 0 13 78 -73 94 -104 8 -16 12
-40 8 -57 l-5 -29 26 17 c21 14 27 14 27 4 0 -8 18 -20 40 -27 40 -13 54 -30
25 -30 -22 0 -18 -18 8 -31 30 -16 38 -31 25 -46 -6 -7 -7 -13 -2 -13 5 0 22
-10 38 -23 l29 -23 -33 -90 c-81 -222 -195 -391 -381 -568 -89 -84 -304 -243
-421 -310 -27 -15 -48 -29 -48 -32 0 -19 331 67 525 136 195 70 447 183 548
247 23 15 67 42 97 61 96 61 270 187 270 196 0 5 -38 68 -84 140 -46 72 -149
239 -228 372 -163 271 -295 466 -373 550 -5 6 -24 26 -41 45 -68 74 -126 109
-181 109 -27 0 -43 -9 -72 -37z"/>
<path d="M5780 4796 l0 -435 96 -3 c53 -2 98 0 99 3 2 3 5 132 6 287 2 155 5
282 9 282 3 0 11 -9 17 -20 15 -22 147 -192 312 -400 63 -80 116 -147 118
-149 2 -3 159 -5 188 -2 7 1 9 151 7 436 l-2 435 -100 0 -100 0 -1 -287 c0
-272 -1 -287 -17 -264 -14 20 -79 105 -125 161 -7 8 -79 99 -161 203 l-148
187 -99 0 -99 0 0 -434z"/>
<path d="M7025 4989 c-90 -8 -128 -23 -192 -71 -79 -60 -122 -172 -109 -290
17 -165 117 -254 314 -280 103 -13 228 -1 303 28 l39 16 0 70 c0 63 -2 69 -17
63 -137 -52 -261 -63 -341 -30 -53 22 -94 69 -90 104 l3 26 243 3 242 2 0 63
c0 215 -142 321 -395 296z m152 -136 c23 -15 53 -70 53 -97 0 -14 -19 -16
-150 -16 -136 0 -150 2 -150 18 0 25 36 79 62 93 53 29 142 30 185 2z"/>
<path d="M9740 4990 c-41 -4 -103 -15 -138 -25 l-63 -18 2 -59 c1 -32 5 -60 8
-62 3 -2 47 7 96 20 176 45 295 20 307 -66 l3 -25 -130 -6 c-160 -7 -253 -37
-309 -99 -80 -89 -53 -230 54 -282 37 -18 63 -22 145 -22 110 -1 173 19 228
71 15 15 28 25 28 22 1 -2 3 -17 5 -33 6 -51 6 -51 99 -48 l87 4 -4 221 c-3
213 -4 224 -28 272 -54 109 -182 153 -390 135z m220 -393 c0 -48 -25 -80 -90
-112 -45 -23 -129 -24 -163 -2 -34 22 -44 70 -22 103 26 40 69 53 178 54 l97
0 0 -43z"/>
<path d="M8370 4970 c-142 -51 -223 -186 -206 -344 11 -107 76 -200 174 -247
103 -51 299 -47 409 7 65 31 122 95 147 163 28 78 19 222 -17 284 -37 63 -99
112 -170 136 -84 29 -258 29 -337 1z m245 -124 c113 -47 128 -271 23 -336 -97
-59 -227 -20 -259 78 -17 51 -6 167 18 200 50 68 138 91 218 58z"/>
<path d="M9310 4969 c-25 -11 -62 -37 -82 -57 l-38 -36 0 52 0 52 -95 0 -95 0
2 -312 c3 -359 -10 -323 121 -312 l77 6 0 183 0 183 27 33 c39 46 96 69 176
69 l67 0 0 80 0 80 -57 0 c-36 0 -75 -8 -103 -21z"/>
<path d="M7420 4973 c0 -3 22 -32 48 -62 27 -31 83 -98 126 -149 l79 -92 -59
-68 c-33 -37 -76 -87 -96 -112 -20 -25 -52 -63 -72 -85 -24 -28 -31 -42 -23
-47 7 -5 56 -8 109 -7 l98 1 43 52 c23 28 58 72 77 98 19 26 38 48 41 48 6 0
50 -53 112 -135 23 -31 48 -52 65 -56 42 -10 190 -10 196 0 7 10 -8 30 -142
189 -94 111 -103 125 -90 140 123 145 226 270 232 280 6 9 -17 12 -103 12
l-109 0 -73 -90 c-40 -49 -76 -90 -80 -90 -4 0 -40 40 -80 90 l-74 90 -112 0
c-62 0 -113 -3 -113 -7z"/>
<path d="M5226 4838 c4 -32 3 -39 -5 -28 -9 13 -11 12 -11 -4 0 -18 -1 -18
-12 -4 -16 20 -65 31 -73 17 -4 -6 -13 -8 -21 -5 -8 3 -19 -3 -26 -13 -6 -11
-18 -17 -25 -14 -8 3 -13 -2 -13 -14 0 -11 -16 -28 -40 -43 -22 -14 -40 -28
-40 -32 0 -5 -16 -8 -35 -8 -28 0 -44 -8 -76 -40 -45 -45 -49 -46 -49 -25 0
12 -16 15 -80 15 -64 0 -80 -3 -80 -15 0 -18 -26 -20 -33 -2 -4 10 -7 10 -18
0 -18 -17 -29 -16 -29 2 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15 0 -8 -3 -15 -7
-15 -5 0 -8 26 -7 57 1 32 -1 41 -3 21 -2 -21 -8 -38 -14 -38 -5 0 -9 -31 -9
-70 0 -38 -4 -79 -9 -92 -16 -39 -54 -306 -47 -331 8 -32 93 -119 243 -249 17
-14 44 -33 59 -41 l29 -16 -35 2 c-19 2 -56 13 -82 26 -26 12 -51 20 -56 17
-4 -2 -14 9 -21 26 -8 17 -16 25 -20 19 -4 -5 -17 -8 -29 -4 -16 4 -21 11 -17
24 4 12 -1 21 -14 29 -17 9 -20 8 -14 -6 4 -11 2 -15 -4 -11 -6 4 -8 -3 -5
-18 2 -14 8 -22 13 -19 5 3 6 -2 2 -11 -3 -10 0 -21 8 -26 11 -7 11 -9 -3 -9
-11 0 -18 7 -18 18 0 16 -9 17 -97 11 -78 -5 -102 -3 -120 8 -13 9 -23 13 -23
10 0 -9 -88 30 -120 53 -16 11 -36 20 -45 20 -9 0 -19 9 -22 19 -7 26 -54 35
-60 11 -4 -16 -30 -29 -57 -30 -4 0 -6 11 -4 25 6 30 -7 34 -15 5 -3 -11 1
-27 9 -34 8 -8 14 -20 14 -26 0 -7 7 -9 16 -6 8 3 12 2 9 -3 -3 -5 11 -27 30
-48 19 -21 35 -41 35 -45 0 -3 12 -19 28 -35 72 -76 93 -106 80 -115 -10 -7
-10 -11 -1 -15 7 -2 33 -21 58 -42 78 -64 295 -162 282 -127 -4 9 2 11 20 8
17 -3 21 -7 12 -13 -23 -14 37 -22 139 -16 101 5 203 32 244 65 64 51 119 108
124 129 4 12 10 23 14 23 13 0 28 55 23 82 -3 17 1 30 14 39 56 42 105 270
144 670 33 340 33 349 20 349 -8 0 -9 -14 -5 -42z m-306 -172 c0 -3 -4 -8 -10
-11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-180 -60 c0 -3 -4
-8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-180 -21 c0
-8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m-34
-53 c-12 -11 -18 7 -10 30 l8 23 4 -23 c2 -13 1 -26 -2 -30z m-512 -529 c-22
-16 -28 -11 -19 17 6 17 9 19 22 9 13 -11 13 -14 -3 -26z m1026 -173 c0 -5 -5
-10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M5202 4850 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3150 4440 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3882 4065 c6 -14 15 -25 19 -25 5 0 3 11 -3 25 -6 14 -15 25 -19 25
-5 0 -3 -11 3 -25z"/>
<path d="M3950 4080 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M6471 4081 c-8 -5 -11 -16 -7 -26 5 -13 15 -16 46 -13 l40 4 0 -108
0 -108 25 0 c24 0 24 1 27 107 l3 107 40 0 c33 1 40 4 40 21 0 18 -8 20 -100
23 -55 1 -106 -2 -114 -7z"/>
<path d="M6891 3960 l-2 -130 101 0 c93 0 100 1 100 20 0 18 -7 20 -75 20
l-75 0 0 38 0 37 62 0 c52 0 63 3 66 18 3 15 -5 17 -63 17 l-66 0 3 32 c3 28
7 32 33 33 91 3 105 6 105 19 0 17 -44 26 -124 26 l-62 0 -3 -130z"/>
<path d="M7328 4083 c-16 -4 -18 -19 -18 -129 l0 -124 95 0 c88 0 95 1 95 20
0 18 -7 20 -70 20 l-70 0 0 104 c0 58 -3 107 -7 109 -5 2 -16 2 -25 0z"/>
<path d="M7718 4083 c-16 -4 -18 -19 -18 -129 l0 -124 100 0 c93 0 100 1 100
20 0 18 -7 20 -78 20 l-78 0 4 35 4 34 61 3 c50 2 62 7 65 21 3 15 -5 17 -62
17 l-66 0 0 29 c0 16 -3 38 -6 48 -4 11 -3 14 3 6 12 -17 142 -21 148 -5 3 8
3 17 0 22 -5 8 -145 10 -177 3z"/>
<path d="M8175 4071 c-93 -43 -102 -173 -15 -225 62 -36 213 -6 166 33 -13 11
-20 11 -28 3 -18 -18 -93 -15 -118 6 -26 21 -36 87 -18 122 19 35 68 47 116
28 32 -13 40 -13 51 -1 15 17 16 15 -26 37 -41 21 -78 20 -128 -3z"/>
<path d="M8605 4072 c-51 -24 -75 -60 -75 -113 0 -55 26 -95 76 -119 85 -42
189 12 202 103 14 104 -101 176 -203 129z m55 -6 c0 -2 -7 -7 -16 -10 -8 -3
-12 -2 -9 4 6 10 25 14 25 6z m55 -26 c59 -22 64 -119 8 -155 -65 -43 -144 -4
-146 73 -2 73 62 111 138 82z"/>
<path d="M9272 4077 c-13 -7 -39 -41 -60 -76 -20 -36 -42 -66 -47 -68 -6 -2
-30 31 -55 72 -35 58 -50 75 -67 75 -23 0 -23 -2 -23 -125 0 -124 0 -125 23
-125 23 0 23 3 22 70 -2 39 1 72 5 75 4 2 24 -20 45 -50 20 -30 42 -55 48 -55
12 0 32 25 53 67 8 17 22 34 30 37 11 4 14 -9 14 -69 0 -73 1 -75 25 -75 l25
0 0 124 c0 69 -4 127 -8 130 -4 3 -18 -1 -30 -7z m18 -17 c0 -5 -2 -10 -4 -10
-3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z"/>
<path d="M4410 4059 c0 -5 -5 -7 -12 -3 -7 4 -8 3 -4 -5 4 -6 12 -9 17 -5 5 3
16 0 24 -6 8 -7 15 -8 15 -4 0 5 -9 15 -20 22 -13 8 -20 8 -20 1z"/>
<path d="M3950 4040 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4416 3986 c3 -9 11 -16 16 -16 13 0 5 23 -10 28 -7 2 -10 -2 -6 -12z"/>
<path d="M4300 3940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5067 3854 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M4102 3748 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12
-12z"/>
<path d="M8640 3275 c0 -97 3 -126 13 -123 7 3 13 28 15 64 3 67 25 94 62 74
15 -8 20 -23 22 -73 4 -79 22 -81 26 -2 4 86 -24 114 -93 91 -19 -7 -21 -3
-20 40 0 29 -5 49 -12 51 -10 4 -13 -25 -13 -122z"/>
<path d="M6480 3377 c-39 -13 -80 -67 -80 -104 0 -85 87 -147 164 -117 31 12
15 22 -34 21 -68 -3 -93 22 -94 93 -1 67 23 90 97 90 30 0 47 4 42 9 -18 16
-60 19 -95 8z"/>
<path d="M7950 3346 l0 -44 -40 5 c-57 8 -80 -15 -80 -78 0 -41 4 -51 26 -66
22 -14 31 -15 57 -5 21 8 34 8 43 1 17 -14 24 26 22 139 -1 70 -4 92 -15 92
-9 0 -13 -14 -13 -44z m0 -109 c0 -33 -24 -67 -48 -67 -42 0 -68 66 -39 102
31 41 87 18 87 -35z"/>
<path d="M9966 3383 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"/>
<path d="M5697 3366 c-13 -10 -17 -24 -15 -47 3 -28 10 -37 53 -58 34 -18 51
-33 53 -48 4 -29 -30 -47 -74 -38 -40 7 -47 -11 -8 -21 43 -11 103 12 110 43
9 35 -4 54 -55 79 -80 39 -76 84 6 84 27 0 42 4 38 10 -9 15 -87 12 -108 -4z"/>
<path d="M8110 3364 c0 -26 54 -199 64 -206 19 -13 32 11 52 92 10 44 22 80
26 80 4 0 12 -18 18 -40 25 -98 31 -116 40 -130 16 -26 35 7 58 101 12 47 24
94 28 104 5 12 3 16 -6 13 -12 -4 -28 -44 -50 -125 -13 -52 -26 -55 -34 -9
-14 73 -37 136 -51 136 -13 0 -20 -15 -50 -123 -14 -52 -35 -70 -35 -30 0 29
-41 153 -50 153 -6 0 -10 -7 -10 -16z"/>
<path d="M8440 3370 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9422 3268 l3 -113 60 0 c37 0 58 4 55 10 -3 6 -25 10 -49 10 l-44 0
-1 99 c-1 71 -5 100 -14 104 -10 3 -12 -21 -10 -110z"/>
<path d="M9590 3370 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M5873 3341 c-3 -12 -12 -21 -19 -21 -8 0 -14 -7 -14 -15 0 -8 7 -15
15 -15 11 0 15 -13 15 -54 0 -58 16 -86 50 -86 28 0 34 18 8 22 -20 3 -23 9
-26 61 -3 52 -1 57 18 57 28 0 25 19 -6 30 -14 6 -23 14 -19 19 3 5 0 13 -6
16 -6 4 -13 -2 -16 -14z"/>
<path d="M7542 3335 c-7 -14 -16 -25 -22 -25 -5 0 -10 -4 -10 -10 0 -5 7 -10
15 -10 11 0 15 -13 15 -53 0 -59 19 -87 58 -87 29 0 28 18 0 22 -21 3 -23 8
-23 63 0 49 3 60 17 60 9 0 20 4 24 8 4 4 -5 7 -19 7 -20 0 -27 5 -27 19 0 30
-16 33 -28 6z"/>
<path d="M8532 3338 c-6 -16 -16 -28 -22 -28 -5 0 -10 -4 -10 -10 0 -5 7 -10
15 -10 12 0 15 -13 15 -60 0 -61 13 -80 54 -80 23 0 19 14 -6 25 -20 9 -23 18
-23 65 0 51 2 55 23 52 12 -2 22 2 22 7 0 6 -4 12 -10 12 -5 1 -15 2 -22 3 -7
0 -15 12 -19 26 l-6 25 -11 -27z"/>
<path d="M9210 3336 c-5 -14 -15 -26 -22 -26 -8 -1 -7 -6 5 -14 13 -10 17 -28
17 -70 0 -50 3 -58 24 -68 14 -6 33 -7 43 -3 16 6 15 8 -8 17 -28 9 -37 36
-31 91 2 19 9 27 22 27 10 0 22 5 25 10 4 6 -5 10 -19 10 -19 0 -26 5 -26 19
0 31 -19 35 -30 7z"/>
<path d="M10051 3336 c-6 -14 -15 -26 -21 -26 -5 0 -10 -4 -10 -10 0 -5 7 -10
15 -10 12 0 15 -13 15 -58 0 -52 3 -60 24 -72 14 -7 32 -9 43 -5 16 7 15 9 -7
14 -20 6 -26 15 -30 46 -7 54 -1 75 21 75 10 0 21 5 24 10 3 6 -3 10 -13 10
-18 0 -51 28 -44 37 2 3 1 7 -2 10 -3 3 -10 -6 -15 -21z"/>
<path d="M6013 3313 c-13 -2 -23 -11 -23 -18 0 -11 6 -12 26 -4 35 13 64 3 64
-22 0 -14 -7 -19 -25 -19 -30 0 -72 -19 -79 -35 -16 -43 32 -78 79 -57 16 7
26 8 30 1 14 -22 25 6 25 65 0 39 -5 68 -13 74 -16 14 -56 21 -84 15z m67
-107 c0 -35 -64 -53 -76 -21 -9 23 15 45 47 45 24 0 29 -4 29 -24z"/>
<path d="M6639 3291 c-37 -38 -39 -82 -4 -116 63 -64 161 9 125 94 -11 28 -46
51 -76 51 -9 0 -29 -13 -45 -29z m79 -7 c41 -28 19 -114 -29 -114 -49 0 -69
85 -27 114 12 9 25 16 28 16 3 0 16 -7 28 -16z"/>
<path d="M6865 3310 c-3 -6 -17 -7 -31 -4 l-25 6 3 -76 c3 -88 22 -103 26 -21
2 45 7 58 26 70 40 26 55 11 58 -61 4 -85 22 -87 26 -4 3 57 0 67 -19 82 -24
20 -54 23 -64 8z"/>
<path d="M7050 3310 c-8 -5 -23 -7 -33 -4 -16 5 -18 -1 -15 -70 4 -93 22 -106
26 -19 3 67 22 91 62 78 16 -5 20 -17 22 -71 4 -83 22 -88 26 -7 2 52 -1 66
-18 83 -22 22 -46 25 -70 10z"/>
<path d="M7205 3294 c-33 -36 -33 -87 0 -119 25 -25 42 -29 83 -19 35 10 26
23 -11 17 -35 -5 -67 15 -67 43 0 11 15 14 60 14 l60 0 -6 28 c-14 62 -78 81
-119 36z m85 -13 c15 -30 14 -31 -35 -31 -48 0 -55 9 -29 34 21 22 51 20 64
-3z"/>
<path d="M7405 3308 c-32 -17 -45 -39 -45 -79 0 -29 6 -42 27 -59 29 -23 83
-24 91 -2 3 9 -3 11 -21 7 -42 -11 -67 10 -67 55 0 31 5 43 25 56 13 9 33 13
44 9 10 -3 22 -2 25 3 3 6 -4 12 -17 16 -30 8 -39 7 -62 -6z"/>
<path d="M7676 3299 c-21 -16 -26 -29 -26 -64 0 -63 43 -96 105 -81 40 10 29
25 -14 19 -32 -4 -41 -1 -54 17 -23 33 -14 40 49 40 48 0 54 2 54 20 0 26 -43
70 -68 70 -11 0 -31 -9 -46 -21z m82 -26 c14 -23 14 -23 -37 -23 -48 0 -51 1
-41 19 19 37 55 38 78 4z"/>
<path d="M8863 3310 c-28 -12 -43 -40 -43 -84 0 -64 81 -100 128 -56 32 30 30
93 -3 125 -25 26 -45 30 -82 15z m51 -20 c23 -8 26 -15 26 -54 0 -51 -18 -71
-55 -62 -46 12 -57 73 -19 110 18 19 16 19 48 6z"/>
<path d="M9720 3310 c-8 -5 -23 -7 -32 -4 -16 5 -18 -3 -18 -70 0 -41 5 -78
10 -81 6 -4 10 13 10 44 0 59 6 78 31 92 13 6 25 6 39 -3 17 -11 20 -23 20
-75 0 -35 4 -63 10 -63 6 0 10 26 10 58 0 47 4 63 21 78 33 30 53 8 59 -65 7
-81 24 -83 28 -4 2 52 0 65 -18 83 -16 16 -28 20 -43 15 -26 -9 -53 -9 -87 -1
-14 4 -32 2 -40 -4z"/>
<path d="M10183 3310 c-15 -6 -23 -18 -23 -33 0 -29 14 -43 53 -52 21 -6 27
-13 25 -29 -2 -17 -10 -21 -38 -22 -48 -1 -49 -18 -2 -22 46 -4 78 24 67 57
-3 12 -9 21 -13 21 -4 0 -22 9 -40 20 -29 18 -32 23 -21 36 9 11 22 14 42 10
20 -4 27 -2 25 7 -6 15 -46 19 -75 7z"/>
<path d="M6140 3306 c0 -2 14 -36 30 -77 25 -59 29 -79 21 -96 -6 -13 -17 -23
-26 -23 -8 0 -15 -4 -15 -10 0 -14 36 -12 48 3 5 6 28 56 51 110 29 70 36 97
26 97 -7 0 -22 -22 -32 -49 -10 -27 -22 -50 -28 -51 -5 -1 -18 21 -29 49 -10
28 -25 51 -32 51 -8 0 -14 -2 -14 -4z"/>
<path d="M8440 3229 c0 -55 4 -79 11 -77 7 2 11 30 11 68 0 88 -1 90 -12 90
-6 0 -10 -34 -10 -81z"/>
<path d="M9020 3242 c0 -40 5 -73 12 -80 15 -15 54 -16 63 -2 3 6 17 7 31 4
24 -6 24 -6 24 70 0 57 -3 76 -14 76 -9 0 -12 -10 -9 -37 6 -54 -4 -82 -32
-95 -39 -18 -55 3 -55 73 0 33 -4 59 -10 59 -6 0 -10 -29 -10 -68z"/>
<path d="M9589 3273 c-1 -21 -2 -56 -3 -77 -1 -23 4 -41 12 -43 9 -4 12 16 12
76 0 47 -4 81 -10 81 -5 0 -11 -17 -11 -37z"/>
<path d="M9962 3233 c2 -44 7 -78 13 -78 6 0 11 34 13 78 2 65 0 77 -13 77
-13 0 -15 -12 -13 -77z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
